import { FiEdit2, FiPlay } from "react-icons/fi";
import { lessonsPath } from "utils/lessons";

import Link from "next/link";

import clsx from "clsx";

type StudyPlanTaskResourcesProps = {
  type: string;
  task: any;
};

export default function StudyPlanTaskResources(
  props: StudyPlanTaskResourcesProps
): JSX.Element {
  const { task, type } = props;

  const icon =
    type === "questions" ? <FiEdit2 /> : <FiPlay className="-mr-1" />;

  const colors = {
    "ciencias-exatas": "exact",
    "ciencias-humanas": "human",
    linguagens: "languages"
  };

  const color = `bg-subjects-${colors[task.topic.parent.group.slug]}`;

  const resourcePlural = type === "questions" ? "exercícios" : "aulas";

  function resourceCount() {
    if (type == "questions") {
      return `${task.questions.answeredCount}/${task.questions.totalCount}`;
    } else if (type == "lessons") {
      return `${task.lessons.watchedCount}/${task.lessons.totalCount}`;
    }
  }

  function resourcesLink() {
    if (type == "questions") {
      return questionsUrl();
    } else if (type == "lessons") {
      return lessonsPath({
        subject: task.topic.parent,
        topic: { slug: task.topic.slug }
      });
    }
  }

  function questionsUrl() {
    return `/questoes/${task.topic.parent.slug}/${task.topic.slug}`;
  }

  return (
    <Link href={resourcesLink()}>
      <a className="no-underline">
        <div className="h-[44px] flex rounded-md cursor-pointer">
          <div
            className={clsx(
              "h-[44px] min-w-[44px] flex items-center justify-center bg-opacity-10 rounded-l-md",
              color
            )}
          >
            {icon}
          </div>

          <div
            className={clsx(
              "h-[44px] min-w-[44px] flex items-center p-3 w-full bg-opacity-5",
              color
            )}
          >
            <span className="text-emphasis-medium">
              <span className="inline-block mr-1 text-inherit tracking-wider">
                {resourceCount()}
              </span>
              <span className="text-inherit">{resourcePlural}</span>
            </span>
          </div>
        </div>
      </a>
    </Link>
  );
}
